module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.9918f50e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-DemiBold.woff
// module id = 84
// module chunks = 0